module.exports = __webpack_public_path__ + "static/paul-maeyaert-3afa92f79aca4ad9ebdab38e0f6099d3.jpg";